module.exports = __webpack_public_path__ + "static/media/pic1.823241da.jpg";